import { useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const useSearchParam = (key: string = "id"): [string, () => void] => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParamValue = searchParams.get(key) ?? "";

  const clearSearchParam = useCallback(() => {
    const updatedParams = new URLSearchParams(searchParams);
    updatedParams.delete(key);

    navigate(
      {
        pathname: location.pathname,
        search: updatedParams.toString() ? `?${updatedParams.toString()}` : "",
        hash: location.hash
      },
      { replace: true }
    );
  }, [key, location.hash, location.pathname, navigate, searchParams]);

  return [searchParamValue, clearSearchParam];
};

export { useSearchParam };
